import React, { useContext, useEffect, useState } from 'react';

import PipelineSummary from './PipelineSummary';
import EditableName from '../shared/field_inputs/EditableName';
import EditableCurrency from '../shared/field_inputs/EditableCurrency';
import EditableOwner from '../shared/field_inputs/EditableOwner';

import { ResolveDealButtons, ReOpenDealButton } from '../shared/CrmButtonGroups';
import { PersonTag, CustomerTag } from '../shared/Tags';
import DetailsDropdown from '../shared/DetailDropdown';
import { DataContext as MainDataContext } from '../../../store';
import { DataContext } from '../../../stores/crm-deal-store';

const DealHeader = ({ activeDeal, updateDealProps }) => {
    const {
        store: { user },
    } = useContext(MainDataContext);

    const {
        store: { pipelines, currentPipelineId },
        dispatch,
    } = useContext(DataContext);

    const [isOwner, setIsOwner] = useState(activeDeal.owner.id === user.crmUserId);

    useEffect(() => {
        setIsOwner(activeDeal.owner.id === user.crmUserId);
    }, [activeDeal]);

    const updateStore = (newDeal) => {
        if (typeof pipelines[currentPipelineId] !== undefined && pipelines[currentPipelineId]?.pipelineStages !== undefined) {
            const dealInPipelineStage = pipelines[currentPipelineId].pipelineStages.find(
                (pipelineStage) => pipelineStage.id === newDeal.pipelineStageId
            );

            const dealsInPipelineStage = dealInPipelineStage.deals;
            const indexToUpdate = dealsInPipelineStage.findIndex((p) => p.id === newDeal.id);
            dealsInPipelineStage[indexToUpdate] = newDeal;

            if (indexToUpdate >= 0) {
                dispatch({
                    type: 'UPDATE_FETCH_PIPES',
                    pipelines: pipelines,
                });
            }
        }
        dispatch({
            type: 'UPDATE_ACTIVE_DEAL',
            payload: newDeal,
        });
    };

    const pipelineSummaryUpdateStore = (newDeal, oldDeal) => {
        if (typeof pipelines[currentPipelineId] !== undefined && pipelines[currentPipelineId]?.pipelineStages !== undefined) {
            const dealInPipelineStage = pipelines[currentPipelineId].pipelineStages.find(
                (pipelineStage) => pipelineStage.id === oldDeal.pipelineStageId
            );

            if (dealInPipelineStage) {
                const dealsInPipelineStage = dealInPipelineStage.deals;
                const indexToDelete = dealsInPipelineStage.findIndex((p) => p.id === oldDeal.id); //Tar bort i gammla storen
                if (indexToDelete >= 0) {
                    dealsInPipelineStage.splice(indexToDelete, 1);
                    dealInPipelineStage.amount -= 1;

                    dispatch({
                        type: 'UPDATE_FETCH_PIPES',
                        pipelines: pipelines,
                    });
                }
            }

            const columnIndex = pipelines[currentPipelineId].pipelineStages.findIndex((s) => s.id === newDeal.pipelineStageId);
            if (columnIndex >= 0) {
                pipelines[currentPipelineId].pipelineStages[columnIndex].deals.splice(0, 0, newDeal);
                pipelines[currentPipelineId].requestObject.amount += 1;

                dispatch({
                    type: 'UPDATE_FETCH_PIPES',
                    pipelines: pipelines,
                });
                dispatch({
                    type: 'UPDATE_ACTIVE_DEAL',
                    payload: newDeal,
                });
            }
        }
    };

    return (
        <div className='d-flex flex-column card detail-card-header w-100'>
            <div className='d-flex flex-row pb-3'>
                <EditableName
                    description={'Döp om deal:'}
                    customDisplayWrapper={(v) => <h1 className='crm-header'>{v}</h1>}
                    initialValue={activeDeal.name}
                    handleSave={(v) => updateDealProps(activeDeal, { name: v })}
                    updateStore={updateStore}
                />
                <div className='d-flex ml-auto flex-row justify-content-center align-items-center'>
                    <EditableOwner
                        initialValue={activeDeal.owner}
                        handleSave={(v) => updateDealProps(activeDeal, {owner: v})}
                        updateStore={updateStore}
                    />
                    <ReOpenDealButton activeDeal={activeDeal} updateStore={updateStore} />
                    <ResolveDealButtons activeDeal={activeDeal} updateStore={updateStore} />
                    {isOwner ? <DetailsDropdown itemType='deal' /> : null}
                </div>
            </div>
            <div className='d-flex mr-auto flex-row pb-3 align-items-baseline'>
                <EditableCurrency
                    description={'Ändra belopp:'}
                    customDisplayWrapper={(v) => <h2 className='crm-header'>{v}</h2>}
                    initialValue={activeDeal.value}
                    handleSave={(v) => updateDealProps(activeDeal, { value: v })}
                    updateStore={updateStore}
                />
                <PersonTag item={activeDeal.contact ? activeDeal.contact : null} />
                <CustomerTag item={activeDeal.customer} />
            </div>
            <PipelineSummary
                initialPipelineStage={activeDeal.pipelineStage}
                handleSave={(v) =>
                    updateDealProps(activeDeal, {
                        pipelineStage: v.pipelineStage,
                    })
                }
                updateStore={pipelineSummaryUpdateStore}
            />
        </div>
    );
};

export default DealHeader;
